var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountBalance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7652_1730",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7652_1730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75028 17.0008V9.50084H7.25028V17.0008H5.75028ZM11.2503 17.0008V9.50084H12.7503V17.0008H11.2503ZM2.76953 20.5008V19.0008H21.231V20.5008H2.76953ZM16.7503 17.0008V9.50084H18.2503V17.0008H16.7503ZM2.76953 7.50084V6.07784L12.0003 1.55859L21.231 6.07784V7.50084H2.76953ZM6.31553 6.00084H17.685L12.0003 3.25084L6.31553 6.00084Z",
    fill: "#0048B6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBalance);
export default __webpack_public_path__ + "static/media/account_balance.931473139a4a07b0014a65f81445f588.svg";
export { ForwardRef as ReactComponent };